module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kd-Ld.8ba04aec.png";